import React from 'react';
import AvatarContainer from './AvatarContainer.jsx';
import UserLoginForm from './UserLoginForm.jsx';
import UserProfileForm from './UserProfileForm.jsx';
import CommentForm from './CommentForm.jsx';
import {MODE_REPLY} from "../utils/constants";

class CommentFormWithAvatar extends React.Component {

    state = {
        showLogin: false,
        showProfile: false
    };

    componentDidMount() {
        this.props.sendResizeEvent();
    }

    componentDidUpdate() {
        this.props.sendResizeEvent();
    }

    onHide = () => {

        this.setState({ showProfile: false, showLogin: false });
    };

    onToggleProfile = () => {

        if (this.state.showProfile) {
            return this.onHide();
        }

        const showLogin = !this.props.userId;

        this.setState({ showLogin }, () => {

            this.props.getUser()
                .then(() => {
                    this.setState({
                        showLogin: false,
                        showProfile: !showLogin
                    });
                })
                .catch(() => this.onHide);
        });
    };

    get avatarButton() {

        return (
            <button
                type="button"
                onClick={this.onToggleProfile}
                className={(this.state.showLogin || this.state.showProfile) ? 'selected' : ''}
            >
                <span className="icon-settings" />
            </button>
        );
    }

    get right() {

        if (this.state.showLogin && this.props.onUser) {
            return (
                <UserLoginForm
                    {...this.props}
                    close={this.props.onUser.reject}
                    authUiConfig={this.props.authUiConfig}
                />
            );
        }

        if (this.state.showProfile) {
            return (
                <UserProfileForm
                    {...this.props}
                    close={this.onHide}
                />
            );
        }

        return (
            <CommentForm
                key={`${this.props.mode}/${this.props.commentId}`}
                {...this.props}
                mode={this.props.mode}
                commentId={this.props.commentId}
            />
        );
    }

    render() {
        return (
            <div className="comment-form-with-avatar">
                <AvatarContainer
                    image={this.props.userPhotoURL}
                    button={this.avatarButton}
                    right={this.right}
                />
            </div>
        );
    }
}

export default CommentFormWithAvatar;


// WEBPACK FOOTER //
// ./src/components/CommentFormWithAvatar.jsx